import React, { useEffect, useState } from "react";
import { GetApp } from "@mui/icons-material";

import {LinearProgress, Stack,Table,TableBody, TableCell, TableHead, TableRow, Box, IconButton, Tooltip } from "@mui/material";

import dashboardService from '../../../services/hoa-dashboard-api-service';
interface PropertiesProps {
	selectedValues : any,
	height: number;
	mails:any;
	setMails:any;
}
const toolbar = 64;
const filterComponent = 103;
const tabHeader = 48;
const tabHeading = 65;
const tableHeader = 57;
const responsiveHeight = toolbar + filterComponent + tableHeader + tabHeader + tabHeading + 1;

const tabWidth = ["40%", "15%", "15%", "15%", "15%"];

export default function MailTab(props: PropertiesProps) {
	const {selectedValues, height, mails,setMails} = props;
	const [loading, setLoading] = useState(false);

	const numberOfProjects = Math.ceil((window.innerHeight - responsiveHeight) / 60)

	useEffect(()=>{
		if(mails.data.length <= 0) {
			getAssignedMails(mails.pageNumber);
		}
	},[])

	async function handleScroll(e:any){
		const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight;
		if (bottom && !mails.isLastPage) {
			await getAssignedMails(mails.pageNumber);
		}
	}

	async function getAssignedMails(page: number){
		if (!loading || mails.data.length < mails.count) {
			setLoading(true);
			const { status, data } = await dashboardService.getAssignedMail(selectedValues.objectId, numberOfProjects, page);
			if(status == 200) {
				const { mailList, totalCount } = data;

				let isLastPage = [...mails.data, ...mailList].length >= totalCount
				setMails({
					...mails,
					data: [...mails.data, ...mailList],
					pageNumber: mails.pageNumber+1,
					count: totalCount,
					isLastPage: isLastPage
				})
			}
			setLoading(false);
		}
	}

	return (
		<div>
			<Stack
				padding={"24px"}
				direction={"row"}
				justifyContent={"space-between"}
				flexWrap={"wrap"}
				borderBottom={"1px solid #E8E8E8"}
			>
				<Stack direction={"column"}>
					<Box component={'span'} className="text-787878-14px bold">Assigned Mails: {mails.count}</Box>
				</Stack>
			</Stack>
			{loading ? <LinearProgress style={{ height: "2px", position: 'sticky', top: 0}} /> : null}
			<TableContainer 
				mails={mails} 
				setMails={setMails} 
				loading={loading} 
				setLoading={setLoading} 
				propertyId={selectedValues.objectId} 
				handleScroll={handleScroll}
				height={height}
			/>
		</div>
	);
}

const TableContainer = ({mails, setMails, loading, setLoading, propertyId, handleScroll, height} : any) => {

	const getFormattedDate = (dateText:string)=>{
		if(dateText) {
			const date = new Date(dateText);
			return date.toLocaleDateString();
		}
		else {
			return "N/A"
		}

	}

	const getMailAssignDate = (mail:any) => {
		if (!mail) {
			return;
		}

		let mailAssignDate:any;

		if (Array.isArray(mail.propertyAssignDates) && mail.propertyAssignDates.length > 0) {
			for (const assignDateObj of mail.propertyAssignDates) {
				if (assignDateObj.propertyId === propertyId) {
					mailAssignDate = assignDateObj.assignDate
				}
			}
		}

		if (!mailAssignDate) {
			mailAssignDate = mail.updatedAt
		}

		return getFormattedDate(mailAssignDate);
	}

	const defaultNoDataContainer = () => {
		return (
			<Stack direction={"column"} justifyContent={"center"} alignItems={"center"}>
                <img style={{ width: "200px", height: "200px" }} src="images/logo/no-wallpaper.png" />
				<Box component={'span'} className="text-787878-16px bold">No mail has been assigned yet</Box>
			</Stack>
		);
	};

    const downloadDocument = async (e: any, fileUrl: any) => {
        e.stopPropagation();
        if(!fileUrl) {
            return;
        }
        let path = `hoaMails/${fileUrl?.name}`
        const documentUrl = await dashboardService.getSignedUrl(path);

        if(documentUrl && documentUrl.data) {
            window.open(String(documentUrl.data), '_blank');
        }
    }

	return (
		<div style={{height: height, overflowY: 'auto'}} onScroll={(e)=>{handleScroll(e)}}>
		{
			mails.data.length > 0 &&
				<Table stickyHeader>
					<TableHead>
						<TableRow
							sx={{
								"& th": {
									color: "#3E3E3E",
									backgroundColor: "#F7F7F7",
								},
							}}
						>
							{["Document Name", "ID", "Document Type", "Assign Date", ""].map(
								(title: string, index: number) => {
									return (
										<TableCell key={index} style={{width: tabWidth[index]}}>
											<span className="text-3E3E3E-14px bold">{title}</span>
										</TableCell>
									);
								}
							)}
						</TableRow>
					</TableHead>
					<TableBody>
						{
							mails.data.map((mail: any, index:number)=>{
								return (
								<TableRow
									sx={{
										"& th": {
											color: "#3E3E3E",
											backgroundColor: "#F7F7F7",
										},
									}}
									key={index}
								>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{mail?.attachmentDetails?.name}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{mail?.objectId}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{mail?.documentType}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{getMailAssignDate(mail)}</span>
									</TableCell>
									<TableCell>
									<Tooltip title="Download">
										<IconButton onClick={(e)=>downloadDocument(e, mail?.attachmentDetails)}>
											<GetApp />
										</IconButton>
									</Tooltip>
									</TableCell>
								</TableRow>)
							})
						}
					</TableBody>
				</Table>
		}
		{
			mails.data.length === 0 && !loading && defaultNoDataContainer()
		}
		</div>
	);
};
